<h2 mat-dialog-title>
  {{ "DIALOGS.ARE_YOU_SURE" | translate }}
  <div *ngIf="action === 'retry'">
    {{ "PAYMENT_HUB_ACTIONS.RETRY" | translate }} ({{ workflowInstanceKey }})
  </div>
  <div *ngIf="action === 'resolve'">
    {{ "PAYMENT_HUB_ACTIONS.RESOLVE" | translate }} ({{ workflowInstanceKey }})
  </div>
</h2>

<mat-dialog-actions>
  <button mat-raised-button color="warn" [mat-dialog-close]="">
    {{ "DIALOGS.CLOSE" | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="takeAction()">
    {{ "DIALOGS.CONFIRM" | translate }}
  </button>
</mat-dialog-actions>
